import { makeArticleHeading } from './internal/makeArticleHeading';

/**
 * @deprecated
 *
 * Компонет типографики для оформления заголовков в больших текстах
 */
export const ArticleHeading0 = makeArticleHeading({
  fontSize: '38px',
  lineHeight: '46px'
});

/**
 * Компонет типографики для оформления заголовков в больших текстах
 */
export const ArticleHeading1 = makeArticleHeading({
  fontSize: '28px',
  lineHeight: '36px'
});

/**
 * Компонет типографики для оформления заголовков в больших текстах
 */
export const ArticleHeading2 = makeArticleHeading({
  fontSize: '22px',
  lineHeight: '28px'
});

/**
 * Компонет типографики для оформления заголовков в больших текстах
 */
export const ArticleHeading3 = makeArticleHeading({
  fontSize: '18px',
  lineHeight: '24px'
});

/**
 * Компонет типографики для оформления заголовков в больших текстах
 */
export const ArticleHeading4 = makeArticleHeading({
  fontSize: '16px',
  lineHeight: '22px'
});

/**
 * Компонет типографики для оформления заголовков в больших текстах
 */
export const ArticleHeading5 = makeArticleHeading({
  fontSize: '14px',
  lineHeight: '20px'
});

/**
 * Компонет типографики для оформления заголовков в больших текстах
 */
export const ArticleHeading6 = makeArticleHeading({
  fontSize: '12px',
  lineHeight: '18px'
});